export const convertFile = async (file: File | string): Promise<string[]> => {
  if (typeof file === 'string') {
    return [file, 'url'];
  }
  try {
    const reader = new FileReader();
    const result = await new Promise<string>((resolve) => {
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          resolve('error');
        }
      };
      reader.onerror = () => resolve('error');
      reader.readAsDataURL(file);
    });
    return [result, 'base64'];
  } catch {
    return ['error', 'error'];
  }
};
